// MultiBackendWrapper.jsx
import { DndProvider } from "react-dnd";
import { MultiBackend, HTML5DragTransition, TouchTransition } from "dnd-multi-backend";

export default function MultiBackendWrapper(props: any) {
    const { children } = props;
    const HTML5toTouch = {
  backends: [
    {
      backend: require('react-dnd-html5-backend').HTML5Backend,
      transition: HTML5DragTransition,
    },
    {
      backend: require('react-dnd-touch-backend').TouchBackend,
      options: { enableMouseEvents: true },
      transition: TouchTransition,
    },
  ],
};
  return (
    <DndProvider backend={MultiBackend} options={HTML5toTouch}>
      {children}
    </DndProvider>
  );
}
